"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SkipAuthentication_1 = require("./SkipAuthentication");
exports.default = SkipAuthentication_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/SkipAuthentication/index.js
// module id = 1715
// module chunks = 8